import * as React from "react";
import PolizaForm from "./form/PolizaForm";
import { generateDefaultPoliza } from "./utils";
import { polizaGroupButtonsMode } from "./form/components/PolizaGroupButtons";
import { colorStatus } from "./helper/polizaHelper";
import "./poliza.scss";

var EditPoliza = function EditPoliza(props) {
  var _props$companies = props.companies,
      companies = _props$companies === void 0 ? [] : _props$companies,
      _props$regions = props.regions,
      regions = _props$regions === void 0 ? [] : _props$regions,
      _props$channels = props.channels,
      channels = _props$channels === void 0 ? [] : _props$channels,
      contratante = props.contratante,
      beneficiario = props.beneficiario,
      beneficiarios = props.beneficiarios,
      asegurado = props.asegurado,
      payment_information = props.payment_information,
      commission = props.commission,
      itemAsegurados = props.itemAsegurados,
      additionalFiles = props.additionalFiles,
      document = props.document,
      assist_card = props.assist_card,
      _props$comunas = props.comunas,
      comunas = _props$comunas === void 0 ? [] : _props$comunas,
      _props$banks = props.banks,
      banks = _props$banks === void 0 ? [] : _props$banks,
      poliza = props.poliza,
      token = props.token,
      step = props.step,
      callOldForm = props.callOldForm,
      endorsement_types = props.endorsement_types,
      cancel_reasons = props.cancel_reasons,
      can_manage_endorsement = props.can_manage_endorsement,
      _props$insurance_brok = props.insurance_broker_agents,
      insurance_broker_agents = _props$insurance_brok === void 0 ? [] : _props$insurance_brok;
  var companiesOption = companies && companies.map(function (company) {
    return {
      label: company.name,
      value: company.id
    };
  });
  var banksOption = banks && banks.map(function (bank) {
    return {
      label: bank.name,
      value: bank.id
    };
  });
  var defaultPoliza = generateDefaultPoliza({
    poliza: poliza,
    beneficiario: beneficiario,
    contratante: contratante,
    asegurado: asegurado,
    beneficiarios: beneficiarios,
    itemAsegurados: itemAsegurados,
    payment_information: payment_information,
    commission: commission
  });

  var filename = function filename(urlList) {
    return urlList[urlList.length - 1];
  };

  var generateFileFormat = function generateFileFormat(file) {
    return file && {
      url: file === null || file === void 0 ? void 0 : file.url,
      name: (file === null || file === void 0 ? void 0 : file.url) && filename(file === null || file === void 0 ? void 0 : file.url.split("/"))
    };
  };

  var additionalFilesFormat = additionalFiles && additionalFiles.map(function (additionalFile) {
    var _additionalFile$file, _additionalFile$file2;

    return {
      url: additionalFile === null || additionalFile === void 0 ? void 0 : (_additionalFile$file = additionalFile.file) === null || _additionalFile$file === void 0 ? void 0 : _additionalFile$file.url,
      id: additionalFile === null || additionalFile === void 0 ? void 0 : additionalFile.id,
      name: (additionalFile === null || additionalFile === void 0 ? void 0 : (_additionalFile$file2 = additionalFile.file) === null || _additionalFile$file2 === void 0 ? void 0 : _additionalFile$file2.url) && filename(additionalFile.file.url.split("/"))
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid cntEditPoliza"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-header"
  }, /*#__PURE__*/React.createElement("h3", null, "Editar Poliza ", poliza.code), /*#__PURE__*/React.createElement("h4", null, colorStatus(poliza.status), /*#__PURE__*/React.createElement("b", null, poliza.status, poliza.sub_status ? " - ".concat(poliza.sub_status) : ""))), /*#__PURE__*/React.createElement(PolizaForm, {
    defaultPoliza: defaultPoliza,
    companiesOption: companiesOption,
    token: token,
    mode: defaultPoliza.draft ? polizaGroupButtonsMode.edit : polizaGroupButtonsMode.endorsement,
    channels: channels || [],
    regions: regions || [],
    comunas: comunas || [],
    banksOption: banksOption,
    companies: companies,
    additionalFiles: additionalFilesFormat,
    document: generateFileFormat(document.document),
    assist_card: generateFileFormat(assist_card.assist_card),
    defaultStep: step && parseInt(step),
    endorsement_types: endorsement_types,
    cancel_reasons: cancel_reasons,
    can_manage_endorsement: can_manage_endorsement,
    insuranceBrokerAgents: insurance_broker_agents
  }));
};

export default EditPoliza;